import { render } from "./LinkIcon.vue?vue&type=template&id=9ca5fefe&scoped=true"
import script from "./LinkIcon.vue?vue&type=script&lang=js"
export * from "./LinkIcon.vue?vue&type=script&lang=js"

import "./LinkIcon.vue?vue&type=style&index=0&id=9ca5fefe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca5fefe"]])

export default __exports__